import { useEffect } from 'react';
import UseScreenSize from '@/hooks/UseScreenSize';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { gameActions } from '@/store/reducers/game';

import Navbar from '@/components/Navbar/Navbar';

const SkillView = () => {
  const { isDesktop } = UseScreenSize();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (isDesktop) {
      dispatch(gameActions.resetAllSelected());
      navigate('/dashboard/games');
    }
  }, [isDesktop]);

  return (
    <>
      <Navbar decreaseOpacity={false} />
    </>
  );
};

export default SkillView;
